import { Link } from "react-router-dom";
import { Heart, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <section className="min-h-[70vh] grid place-items-center px-4 py-24 relative z-10" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-2xl border border-plum/10 p-10 text-center">
        <Heart className="text-gold-dark mx-auto" size={48} />
        <h1 className="font-heading text-3xl text-plum font-semibold mt-6">Your gift wasn't completed</h1>
        <p className="text-stone mt-3">No worries — nothing was charged. Whenever you're ready, your support makes a real difference in our community.</p>
        <div className="flex flex-wrap gap-4 justify-center mt-8">
          <Link to="/get-involved" className="bg-gold hover:bg-gold-dark text-plum font-semibold rounded-full px-7 py-3.5 flex items-center gap-2 transition-all hover:-translate-y-1" data-testid="cancel-retry-btn">
            <Heart size={17} /> Give Again
          </Link>
          <Link to="/" className="border border-plum/25 text-plum rounded-full px-7 py-3.5 hover:bg-plum hover:text-cream transition-colors flex items-center gap-2" data-testid="cancel-home-btn">
            <ArrowLeft size={16} /> Back Home
          </Link>
        </div>
      </div>
    </section>
  );
}
